var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n  QR Code Scanner\n  "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_scanner.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Title" },
            model: {
              value: _vm.$v.data_scanner.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_scanner.title, "$model", $$v)
              },
              expression: "$v.data_scanner.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_scanner.description.$error } },
        [
          _c("label", [_vm._v(" Description ")]),
          _vm._v(" "),
          _c("j-textarea", {
            attrs: { placeholder: "Description" },
            model: {
              value: _vm.$v.data_scanner.description.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_scanner.description, "$model", $$v)
              },
              expression: "$v.data_scanner.description.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_scanner.function_name.$error } },
        [
          _c("label", [_vm._v(" Function Name ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.listFunction,
              placeholder: "Select Function Name",
              label: "name"
            },
            model: {
              value: _vm.$v.data_scanner.function_name.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_scanner.function_name, "$model", $$v)
              },
              expression: "$v.data_scanner.function_name.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "information" }, [
        _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("Information")]),
          _vm._v(" "),
          _c(
            "span",
            [
              _vm._v(
                "\n        QR Code Scanner widget will only show on mobile view but not support for Offline Mode.\n        Click\n        "
              ),
              _c(
                "b-link",
                {
                  attrs: {
                    href:
                      "https://docs.officeless.studio/documentation/Visual-Programming/Function-for-widget-QR-Code-Scanner?mod=4nOD53WVR&doc=RNJTrdq4g",
                    target: "_blank"
                  }
                },
                [_c("strong", [_vm._v("here")])]
              ),
              _vm._v(
                "\n        for detailed requirements function response\n      "
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeScanner }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveScanner } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d97f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d97f62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-component/jQRCodeSetup.vue
// module id = null
// module chunks = 